const CAPTCHA_VERIFICATION_URL = `https://www.google.com/recaptcha/api/siteverify?secret=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}&response=`;

export function verifyCaptchaToken(token) {
  const CAPTCHA_VERIFICATION_URL_WITH_TOKEN = CAPTCHA_VERIFICATION_URL + token;
  const requestOptions = {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Length": "0",
    },
    mode: "no-cors",
  };

  return fetch(CAPTCHA_VERIFICATION_URL_WITH_TOKEN, requestOptions);
}
